<template>
  <svg
    width="54"
    height="54"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.4363 4.50053H18.8138C15.9287 4.45978 13.5534 6.7588 13.5 9.64366V45.6699C13.5534 48.5548 15.9287 50.8538 18.8138 50.813H37.4363C40.3213 50.8538 42.6966 48.5548 42.75 45.6699V9.64366C42.6966 6.7588 40.3213 4.45978 37.4363 4.50053ZM25.0781 8.15678H31.1719V9.37553C31.1719 9.71208 30.899 9.98491 30.5625 9.98491H25.6875C25.351 9.98491 25.0781 9.71208 25.0781 9.37553V8.15678ZM37.4363 47.1568C38.3026 47.1984 39.0414 46.5357 39.0938 45.6699V9.64366C39.0414 8.77789 38.3026 8.11517 37.4363 8.15678H34.8281V9.37553C34.8281 10.5068 34.3787 11.5918 33.5788 12.3918C32.7788 13.1917 31.6938 13.6412 30.5625 13.6412H25.6875C23.3317 13.6412 21.4219 11.7314 21.4219 9.37553V8.15678H18.8138C17.9474 8.11517 17.2086 8.77789 17.1562 9.64366V45.6699C17.2086 46.5357 17.9474 47.1984 18.8138 47.1568H37.4363Z"
      fill="#FFDD00"
    />
  </svg>
</template>